<template>
  <div style="margin-top: 1%; padding-bottom: 2%">
    Dear A. Jones,<br /><br />

    We had already talked about this at our headquarters a few weeks ago: In
    order to continue to secure ATCL's position as the leading
    telecommunications provider in North America, it is important that we
    present our 5G network rollout to the media. I would now like you to take
    care of finding a suitable advertising agency to support us in setting up an
    advertising campaign that will ensure that our "5G for North America"
    project is and remains on everyone's lips. In order to clarify the framework
    and to move the whole project forward as quickly as possible, I would like
    to talk to you personally in my office next Thursday, August 18, at 9:30
    am.<br /><br />

    With kind regards<br /><br />

    Hannah Meyers<br />
    ATCL Headquarters
  </div>
</template>

<script>
import "./styles.css";

export default {
  props: {
    parentFunction: Function,
  },
};
</script>
